import Vue from "vue";
import VueRouter from "vue-router";
import Meta from "vue-meta";

import VueBodyClass from "vue-body-class";

Array.from(document.querySelectorAll("meta[remove]"))
  .concat([document.querySelector("title")])
  .map((meta) => {
    meta.remove();
  });

Vue.use(VueRouter);
Vue.use(Meta, {
  keyName: "metaInfo",
  attribute: "data-vue-meta",
  tagIDKeyName: "vmid",
  refreshOnceOnNavigation: true,
});

function lazyLoad(module, view) {
  return () => import(`../views/modules/${module}/pages/${view}`);
}

function lazyLoadViewerTodo() {
  return () => import("Components/Viewer");
}

const defaultRoutes = [
  {
    path: "/reset-password",
    redirect: "/app/reset-password/new",
  },
  {
    path: "/app",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    component: () => import("Container/AuthLayout"),
    redirect: "/",
    children: [
      {
        path: "/app/login",
        meta: {
          requiresAuth: false,
          skipModuleCheck: true,
        },
        redirect: "/",
        // component: lazyLoad("general", "Login"),
      },
      {
        path: "/app/reset-password",
        meta: {
          requiresAuth: false,
          skipModuleCheck: true,
        },
        redirect: "/",
        // component: lazyLoad("general", "ResetPassword"),
      },
      {
        path: "/app/reset-password/new",
        meta: {
          requiresAuth: false,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "NewPassword"),
      },
    ],
  },
  {
    path: "/AI/demo/login",
    meta: {
      requiresAuth: false,
    },
    component: lazyLoad("general", "DemoLogin"),
  },
  {
    path: "/loading/study/previous",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    component: lazyLoad("general", "LoadingWithRedirect"),
  },

  {
    path: "/loading/study/next",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    component: lazyLoad("general", "LoadingWithRedirect"),
  },

  {
    path: "/user/agreement",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    component: lazyLoad("general", "UserAgreement"),
  },

  {
    path: "/",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    // redirect: "/",
    // alias: "/homepage",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/",
        meta: {
          requiresAuth: false,
          skipModuleCheck: true,
          showBottomAuthBanner: false,
          showHeader: false,
          metaInfo: "home",
        },

        component: lazyLoad("general", "Home"),
      },
      {
        path: "/subscriptions",
        meta: {
          requiresAuth: true,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "Subscriptions"),
      },
      {
        path: "/lk",
        meta: {
          requiresAuth: true,
          skipModuleCheck: true,
        },
        component: lazyLoad("general", "LK"),
      },
    ],
  },
  {
    path: "/homepage",
    meta: {
      requiresAuth: false,
      skipModuleCheck: true,
    },
    redirect: () => {
      // the function receives the target route as the argument
      // we return a redirect path/location here.
      return { path: "/" };
    },
  },
  {
    path: "/AI",
    meta: {
      requiresAuth: false,
    },
    redirect: "/AI/services",
    alias: "/services",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/AI/services",
        alias: "/services",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "ai-services",
        },
        component: lazyLoad("AI", "Services"),
      },
      {
        path: "/AI/calc",
        alias: "/calc",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("AI", "Calc"),
      },
      {
        path: "/AI/studies",
        alias: "/studies",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          authBannerText: "Auth banner text 2",
          metaInfo: "custom",
        },
        component: lazyLoad("AI", "Studies"),
      },
      {
        path: "/AI/view",
        alias: "/view",
        meta: {
          requiresAuth: false,
          bodyClass: "viewer",
          metaInfo: "custom",
        },
        component: lazyLoadViewerTodo(),
      },
    ],
  },
  {
    path: "/edu",
    meta: {
      requiresAuth: false,
      accessInstallations: "ru",
    },
    redirect: "/edu/services",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/edu/services",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "edu-services",
        },
        component: lazyLoad("edu", "Services"),
      },
      {
        path: "/edu/services/:serviceId/lessons",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("edu", "Lessons"),
      },
      {
        path: "/edu/services/:serviceId/lessons/:lessonId/studies",
        meta: {
          requiresAuth: false,
          metaInfo: "custom",
        },
        component: lazyLoad("edu", "Cases"),
      },
      {
        path: "/edu/services/:serviceId/lessons/:lessonId/studies/:studyId/viewer",
        meta: {
          requiresAuth: false,
          bodyClass: "viewer",
          metaInfo: "custom",
        },
        component: lazyLoadViewerTodo(),
      },
    ],
  },
  {
    path: "/community",
    meta: {
      requiresAuth: false,
      accessInstallations: "ru",
    },
    redirect: "/community/cases",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/community/cases",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "community-cases",
        },
        component: lazyLoad("community", "Cases"),
      },
      {
        path: "/community/cases/:caseId",
        meta: {
          requiresAuth: false,
          showBottomAuthBanner: true,
          metaInfo: "custom",
        },
        component: lazyLoad("community", "Case"),
      },
      {
        path: "/community/cases/:caseId/viewer",
        meta: {
          requiresAuth: false,
          bodyClass: "viewer",
          metaInfo: "custom",
        },
        component: lazyLoadViewerTodo(),
      },
    ],
  },
  {
    path: "*",
    redirect: "/AI/404",
    component: () => import("Container/BaseLayout"),
    children: [
      {
        path: "/AI/404",
        component: lazyLoad("general", "PageNotFound"),
      },
    ],
  },
];

const createRouter = () =>
  new VueRouter({
    mode: "history",
    routes: defaultRoutes.filter((route) => {
      return (
        !route.meta?.accessInstallations ||
        route.meta.accessInstallations.indexOf(
          process.env.VUE_APP_INSTALLATION
        ) !== -1
      );
    }),
  });

const router = createRouter();

const vueBodyClass = new VueBodyClass(defaultRoutes);
router.beforeEach((to, from, next) => {
  vueBodyClass.guard(to, next);
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // the relevant part
}

export default router;
